// src/amplifyInit.ts
import { Amplify } from "aws-amplify";
import { I18n } from "aws-amplify/utils";
import { translations } from "@aws-amplify/ui-react";
import awsconfig from "../aws-exports";

// Configurar idioma y traducciones
I18n.putVocabularies(translations);
I18n.setLanguage("es");

I18n.putVocabulariesForLanguage("es", {
  "Reset Password": "Recuperar contraseña", // NOSONAR: translation string, not a credential
  "Enter your email": "Ingrese su email",
  "Sign in to your account": "Ingresa a tu cuenta",
  "Sign In with Google": "INGRESAR CON GOOGLE",
  "Sign In": "INGRESAR",
  "Sign in": "Ingresar",
  "Forgot your password?": "¿Olvidaste tu contraseña?", // NOSONAR: translation string, not a credential
});

// Configurar Amplify con redirecciones actualizadas
awsconfig.oauth.redirectSignIn = `${window.location.origin}/`;
awsconfig.oauth.redirectSignOut = `${window.location.origin}/`;
Amplify.configure(awsconfig);
